/**
 * WordPress dependencies
 */
import domReady from '@wordpress/dom-ready';
import { createRoot } from '@wordpress/element';

/**
 * Internal dependencies
 */
import View from './view/index.tsx';

domReady( () => {
	const elms = document.querySelectorAll( '.wp-block-wdg-job-board' );

	elms.forEach( ( elm ) => {
		// Get data attributes from the block
		const provider = elm.getAttribute( 'data-provider' );
		const settingsAttr = elm.getAttribute( 'data-settings' );

		if ( ! provider ) {
			console.error( 'Job Board: Missing provider attribute' );
			return;
		}

		// Parse settings JSON
		let settings = {};
		if ( settingsAttr ) {
			try {
				settings = JSON.parse( settingsAttr );
			} catch ( error ) {
				console.error( 'Job Board: Failed to parse settings', error );
			}
		}

		const renderElm = elm.querySelector( '.job-board__render' );
		if ( ! renderElm ) {
			console.error( 'Job Board: Missing render element' );
			return;
		}

		const root = createRoot( renderElm );
		root.render(
			<View provider={ provider } settings={ settings } />
		);
	} );
} );
